export enum ProcessStatus {
  NotSpecified = 0,
  Created = 10,
  Running = 20,
  WaitingForUser = 25,
  Completed = 30,
  Closed = 40,
  Failed = 50,
  Discarded = 60,
}
